var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from "@reach/router";
import styled from "styled-components";
export var ButtonLinkOutlined = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  transition: color ", " ease,\n    background-color ", " ease,\n    border-color ", " ease;\n  cursor: pointer;\n  svg {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    line-height: 1;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n  &.icon {\n    display: flex;\n    align-items: center;\n    svg {\n      max-width: 16px;\n      max-height: 16px;\n      margin-right: 3px;\n    }\n  }\n"], ["\n  text-decoration: none;\n  color: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  transition: color ", " ease,\n    background-color ", " ease,\n    border-color ", " ease;\n  cursor: pointer;\n  svg {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    line-height: 1;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n  &.icon {\n    display: flex;\n    align-items: center;\n    svg {\n      max-width: 16px;\n      max-height: 16px;\n      margin-right: 3px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverColor;
});
var templateObject_1;
//# sourceMappingURL=ButtonLinkOutlined.js.map